










































import { Vue, Component, Prop } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import DirectivesService from '@/domain/directives/directives.service';
import DirectiveDefinition from '@/domain/directives/directive-definition.entity';
import WorkItemFilterService from '@/domain/work-item/work-item-filter.service';
import ProjectDirectives from '@/domain/directives/project-directives.entity';
import Project from '@/domain/project/project.entity';
import ProjectUserStore from '@/domain/project/project-with-members.store';
import DirectivesConfigCard from './directives-config-card.component.vue';
import DirectivesProjectCard from './directives-project-card.component.vue';
import DirectivesWorkItemTypeCard from './directives-work-item-type-card.component.vue';
import ProjectDirectivePersist from '../../domain/directives/project-directive-persist.entity';

@Component({
  components: {
    'directives-wi-type-card': DirectivesWorkItemTypeCard,
    'directives-project-card': DirectivesProjectCard,
    'directives-config-card': DirectivesConfigCard,
  },
})
export default class Directives extends Vue {
  private mapperWorkItemTypes: string[] = [];

  private projectDirectives: ProjectDirectives[] = [];

  private selectedWorkItemTypeDirectives: DirectiveDefinition[] = [];

  private allWorkItemTypesDirectives: DirectiveDefinition[] = [];

  private defaultDirectives: DirectiveDefinition[] = [];

  private loading: boolean = false;

  private projectId: string = '';

  private projectIdMapper: string = '';

  private projectsStore = getModule(ProjectUserStore);

  created() {
    this.projectsStore
      .fetchProjects()
      .then(() => this.setProjectId(this.$route.params.projectName))
      .then(() => this.loadDirectivesData(this.projectId));
  }

  private clickCancelModal() {
    this.getAllWorkItemTypesDirectives(this.projectId);
    this.selectedWorkItemTypeDirectives = [];
  }

  beforeRouteUpdate(to: any, from: any, next: any) {
    this.setProjectId(to.params.projectName);
    this.loadDirectivesData(this.projectId);
    next();
  }

  private async setProjectId(projectName: string) {
    await this.projectsStore.getProject(projectName).then(project => (this.projectId = project.id));
  }

  private loadDirectivesData(projectId: string) {
    this.getDefaultDirectives();
    this.getAllWorkItemTypesDirectives(projectId);
    this.getProjectCoreIdMapper(projectId);
  }

  private selectWorkItemType(option: any) {
    if (option === this.allWorkItemTypesDirectives) {
      this.getAllWorkItemTypesDirectives(this.projectId);
    } else if (this.selectedWorkItemTypeDirectives !== option.definitions) {
      this.selectedWorkItemTypeDirectives = option.definitions;
    }
  }

  private updateDirective(directive: any) {
    if (directive.id) {
      const obj: any = { activated: directive.activated, inheritance: directive.inheritance };
      const persistDirective: ProjectDirectivePersist = new ProjectDirectivePersist(obj);
      this.updateProjectDirective(directive.id, persistDirective);
    } else {
      this.updateAllWorkItemTypesDirectives(this.projectId, directive);
    }
  }

  private navigate(name: string, path: string = 'home') {
    if (name) {
      this.$router.push(`/${name}/${path}`);
    }
  }

  private getDefaultDirectives() {
    DirectivesService.getDefaultDirectives().then((res: any) => (this.defaultDirectives = res));
  }

  private getAllWorkItemTypesDirectives(projectId: string) {
    this.loading = true;
    DirectivesService.getAllWorkItemTypesDirectives(projectId).then((res: any) => {
      this.allWorkItemTypesDirectives = res;
      return (this.selectedWorkItemTypeDirectives = this.allWorkItemTypesDirectives);
    }).finally(() => this.loading = false);
  }

  private getProjectCoreIdMapper(projectId: string) {
    this.loading = true;
    DirectivesService.getProjectCoreIdMapper(projectId)
      .then((res: any) => {
        for (let index = 0; index < res.length; index += 1) {
          const element = res[index];
          if (element.integration.id === '4605faee-56d4-40df-b807-20a18582d4a0') {
            this.projectIdMapper = element.id;
          }
        }
      }).finally(() => {
        this.getProjectDirectivesMapper(this.projectIdMapper);
        this.loading = false;
      });
  }

  private getProjectDirectivesMapper(projectIdMapper: string) {
    const exemplo: string[] = [];
    DirectivesService.getProjectDirectivesMapper(projectIdMapper)
      .then((res: any) => {
        for (let index = 0; index < res.rules.length; index += 1) {
          const element = res.rules[index];
          if (element.filters[0].fieldName === 'WorkItemType') {
            exemplo.push(element.filters[0].value);
          }
        }
        this.mapperWorkItemTypes = exemplo;
      }).finally(() => {
        this.getProjectDirectives(this.projectId);
      });
  }


  private getProjectDirectives(projectId: string) {
    DirectivesService.getProjectDirectives(projectId).then(
      (res: any) => {
        this.projectDirectives = res
          .filter((x: any) => this.mapperWorkItemTypes.indexOf(x.workItemType.name) !== -1);
      },
    );
  }

  private updateAllWorkItemTypesDirectives(projectId: string, directive: DirectiveDefinition) {
    this.loading = true;
    DirectivesService.updateAllWorkItemTypes(projectId, directive)
      .then((response: any) => (this.projectDirectives = response))
      .finally(() => (this.loading = false));
  }

  private updateProjectDirective(directiveId: string, directive: ProjectDirectivePersist) {
    this.loading = true;
    DirectivesService.updateProjectDirective(directiveId, directive).finally(
      () => (this.loading = false),
    );
  }
}
